export const config = {
  apiBaseUri: import.meta.env.VITE_API_BASE_URI as string | undefined,
};

export const authConfig = {
  authority: import.meta.env.VITE_AUTH_AUTHORITY as string,
  clientId: import.meta.env.VITE_AUTH_CLIENT_ID as string,
  scopes: import.meta.env.VITE_AUTH_SCOPES as string,
  redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI as string,
  postLogoutRedirectUri: import.meta.env.VITE_AUTH_POST_LOGOUT_REDIRECT_URI as string,
};
